<template>
  <v-card dark>
    <v-card-title v-if="props.title">
      {{ props.title }}
    </v-card-title>
    <v-card-subtitle>
      Upload an image (try to keep it small)
    </v-card-subtitle>
    <v-card-text>
      <v-file-input
        show-size
        label="File input"
        @change="previewImage"
        accept="image/*"
        v-model="file"
        prepend-icon="mdi-camera"
        color="amber"
        :hide-details="true"
      ></v-file-input>
      <div v-if="showPreview">
        <div v-if="imageData || imgPreview != null" class="ma-0">
          <v-progress-linear
            :value="uploadValue"
            v-if="imageData"
          ></v-progress-linear>
          <img class="preview mt-8" :src="imgPreview" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
// import EventBus from "@/utils/eventbus";
const fb = require("@/firebaseConfig.js");

export default {
  name: "InputDropdown",
  props: {
    props: {
      type: Object,
      default: null,
    },
    showPreview: {
      type: Boolean,
      default: true,
    },
    value: String,
  },
  data() {
    return {
      item: this.value,
      imageData: null,
      uploadValue: 0,
      file: null,
      files: [],
    };
  },
  watch: {
    item: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.item = val;
    },
  },
  computed: {
    imgPreview() {
      if (this.item) {
        return this.item;
      } else if (this.preview) {
        return this.preview.src;
      } else {
        return null;
      }
    },
  },
  methods: {
    previewImage: function() {
      this.uploadValue = 0;
      this.item = null;
      this.imageData = event.target.files[0];
      this.onUpload();
    },
    onUpload() {
      this.item = null;
      const storageRef = fb.storage
        .ref(`${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        "state_changed",
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.warn(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.item = url;
          });
        }
      );
    },
  },
};
</script>

<style lang="scss">
.preview {
  width: 100%;
  height: auto;
}
</style>
